export const isFahrenheit = unit => unit === '°F' || unit === 'F' || unit === 'f';
export const isCelsius = unit => unit === '°C' || unit === 'C' || unit === 'c';

export function convertTemperature(fromUnit, toUnit, value, roundToNearest) {
  let result = value;
  if (isCelsius(fromUnit) && isFahrenheit(toUnit)) {
    result = Math.round(parseFloat(value) * (9 / 5) + 32);
  }
  if (isFahrenheit(fromUnit) && isCelsius(toUnit)) {
    result = Math.round((parseFloat(value) - 32) * (5 / 9));
  }
  if (roundToNearest) {
    result = Math.round(result / roundToNearest) * roundToNearest;
  }
  return result;
}

export function toCelsius(unit, value, roundDownToNearest) {
  return convertTemperature(unit, '°C', value, roundDownToNearest);
}

export function toFahrenheit(unit, value, roundDownToNearest) {
  return convertTemperature(unit, '°F', value, roundDownToNearest);
}

export default {
  toCelsius,
  toFahrenheit,
  convertTemperature,
  isFahrenheit,
  isCelsius,
};
